import { setupBlockForm, validateBlockForm, submitBlockForm, resetAttributes } from './block';
import { setupOverrideForm, validateOverrideForm, submitOverrideForm } from './override';

const queryString = require("query-string");

const { appConfig, $, Rollbar, loadingScreen, location, Pikaday, notie } = window;

export default function () {

  $("#edit-inventories").on("click", e => {
    e.preventDefault();

    let url;
    if ($("#restaurant-group").val() === "1") {
      url = "/dashboard/v2/group/inventories/edit.html";
    } else {
      url = "/dashboard/v2/inventories/edit.html";
    }
    $.ajax({
      url,
      success(html) {
        const modal = $(html).simpleModal();
        modal.trigger("show");

        if ($(window).width() < 768) {
          modal.css("left", "3%").css("top", "3%");
        } else {
          modal.css("left", "35%").css("top", "30%");
        }

        modal.find(".edit-seats-modal-cancel").on("click", f => {
          f.preventDefault();
          modal.trigger("hide");
        });

        setupOverrideForm(modal)

        const form = modal.find("form")
        form.on("submit", (event) => {
          const { isValid, message } = validateOverrideForm();
          if (!isValid) {
            event.preventDefault();
            notie.force({
              type: "warning",
              text: message,
              callback: () => {
                modal.find(".submit-edit-seats").prop("disabled", false);
              }
            });
            return false;
          }

          const onFailed = function (text) {
            notie.alert({ text });
          }
          submitOverrideForm(event, modal, onFailed)

          event.preventDefault();
          $.ajax({
            url: form.attr("action"),
            method: form.attr("method"),
            data: form.serialize(),
            CORS: true,
            success(response) {
              if (response.success) {
                notie.alert({ text: response.message });
                // convert date string to Date object
                let date = modal.find('#inventory_start_date').val()
                date = new Date(date)
                window.inventoryChangeDate(date)
                modal.trigger("hide");
                return false;
              } else {
                notie.alert({ text: response.message });
              }
            },
            error(error) {
              notie.alert({ text: "Sorry, something went wrong, we will check this bug" });
              Rollbar.error("owner v2 dashboard edit inventory error", error);
            }
          })
        })
      },
      error(error) {
        Rollbar.error("owner v2 dashboard edit inventory error", error);
      }
    });

    return false;
  });

  $("#block-restaurant").on("click", e => {
    e.preventDefault();
    let url;
    if ($("#restaurant-group").val() == "1") {
      url = `/dashboard/v2/group/inventories/block_form.html?locale=${appConfig.locale}`;
    } else {
      url = `/dashboard/v2/inventories/block_form.html?locale=${appConfig.locale}`;
    }

    $.get(url).done(html => {
      const modal = $(html).simpleModal();
      modal.trigger("show");
      if ($(window).width() < 768) {
        modal.css("left", "3%").css("top", "3%");
      } else {
        modal.css("left", "35%").css("top", "18%");
      }

      setTimeout(() => { setupBlockForm(modal) }, 500)

      modal.find(".cancel-modal").on("click", f => {
        f.preventDefault();
        modal.trigger("hide");
        resetAttributes();
      });

      modal.find("form").submit(f => {
        f.preventDefault();
        let areYouSureWantToBlock;
        let successfullyBlocked;
        let failedBlocking;

        if (appConfig.locale === "th") {
          areYouSureWantToBlock = "แน่ใจว่าต้องการบล็อคร้านอาหารใช่หรือไม่?";
          successfullyBlocked = "ยินดีด้วย คุณได้ทำการปิดกั้นการจองสำเร็จแล้ว";
          failedBlocking = "การบล็อคไม่สำเร็จ กรุณาลองใหม่อีกครั้ง";
        } else {
          areYouSureWantToBlock = "Are you sure you want to block?";
          successfullyBlocked = "Congratulations you have succesfully blocked inventories!";
          failedBlocking = "Block unsuccessful please try again";
        }

        const { isValid, message } = validateBlockForm();
        if (!isValid) {
          notie.force({
            type: "warning",
            text: message,
            callback() {
              modal.find("#submit").prop("disabled", false);
            }
          });
          return;
        }

        notie.confirm({
          text: areYouSureWantToBlock,
          submitCallback() {
            const pw = loadingScreen();
            submitBlockForm(
              modal.find("form").serialize(),
              () => {
                // on finish
                pw.finish();
                setTimeout(() => {
                  notie.alert({ text: successfullyBlocked });
                }, 500);
                modal.trigger("hide");
              },
              errorMsg => {
                // on failed
                pw.finish();
                setTimeout(() => {
                  const msg = `${failedBlocking}. ${errorMsg}`;
                  notie.alert({ text: msg });
                }, 500);
                modal.find('#submit').prop('disabled', false)
              },
              appConfig.restaurantIdentifier
            );
          }
        });
      });
    });
  });
}
